var Preconditions = require('./Preconditions.js'); 

function LocalStorage()
{
    this.is_window_available = true;

    try
    {
        window;
    }
    catch(err)
    {
        this.is_window_available = false;
    }

    this.backstop_map = new Map();
}

LocalStorage.prototype.getItem = function(key)
{
    Preconditions.checkString(key);

    if ( this.is_window_available )
    {
        return window.localStorage.getItem(key);
    }

    return this.backstop_map.get(key);
}

LocalStorage.prototype.setItem = function(key, value)
{
    Preconditions.checkString(key);

    if ( Preconditions.isNull(value) )
    {
        this.deleteItem(key);
        return;
    }

    Preconditions.checkString(value);

    if ( this.is_window_available )
    {
        window.localStorage.setItem(key, value);
        return;
    }

    this.backstop_map.set(key,value);
}

LocalStorage.prototype.deleteItem = function(key)
{
    Preconditions.checkString(key);

    if ( this.is_window_available )
    {
        window.localStorage.removeItem(key);
        return;
    }

    this.backstop_map.delete(key);
}

LocalStorage.prototype.get = function(key, default_value)
{
    let as_str = this.getItem(key);

    if ( Preconditions.isNull(as_str) ) return default_value;

    try
    {
        return JSON.parse(as_str);
    }
    catch(err)
    {
        return default_value;
    }
}

LocalStorage.prototype.set = function(key, value)
{
    Preconditions.checkString(key);

    if ( Preconditions.isNull(value) )
    {
        this.deleteItem(key);
        return;
    }

    this.setItem(key, JSON.stringify(value));
}

LocalStorage.prototype.delete = function(key)
{
    Preconditions.checkString(key);
    this.deleteItem(key);
}

LocalStorage.prototype.has = function(key)
{
    Preconditions.checkString(key);
    return this.get(key,null) != null;
}

module.exports = LocalStorage;